import { create } from 'zustand';
import api from '../utils/api';

const useAuthStore = create((set, get) => ({
  user: null,
  token: localStorage.getItem('token'),
  loading: false,
  initialized: false,

  init: async () => {
    const token = localStorage.getItem('token');
    if (!token) { set({ initialized: true }); return; }
    try {
      const res = await api.get('/auth/me');
      set({ user: res.data.user, initialized: true });
    } catch {
      localStorage.removeItem('token');
      set({ user: null, token: null, initialized: true });
    }
  },

  login: async (email, password) => {
    const res = await api.post('/auth/login', { email, password });
    const { token, user } = res.data;
    localStorage.setItem('token', token);
    set({ token, user });
    return user;
  },

  signup: async (data) => {
    const res = await api.post('/auth/signup', data);
    const { token, user } = res.data;
    localStorage.setItem('token', token);
    set({ token, user });
    return user;
  },

  logout: () => {
    localStorage.removeItem('token');
    set({ user: null, token: null });
  },

  refreshUser: async () => {
    try {
      const res = await api.get('/auth/me');
      set({ user: res.data.user });
    } catch {}
  },
}));

export default useAuthStore;
